import { render, staticRenderFns } from "./Conformidade.vue?vue&type=template&id=5452c69a&"
import script from "./Conformidade.vue?vue&type=script&lang=js&"
export * from "./Conformidade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports